<script lang="ts">
import type { TIconValue } from '@/utils/helper-objects'
import { type PropType, defineComponent } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

export default defineComponent({
  props: {
    icon: {
      type: String as PropType<TIconValue> | null,
    },
    title: {
      type: String,
      required: false,
    },
    viewAllRoute: {
      type: Object as PropType<RouteLocationRaw>,
    },
    nextDisabled: {
      type: Boolean,
      default: false,
    },
    previousDisabled: {
      type: Boolean,
      default: false,
    },
    showNavigation: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['nextClick', 'previousClick'],
})
</script>

<template>
  <div
    class="flex flex-row items-center gap-3 carousel-header @sm/main:min-h-8 empty:hidden"
  >
    <AppIcon v-if="icon" size="sm" class="sm:h-8 sm:w-8" :icon></AppIcon>
    <h2
      v-if="title"
      class="flex-1 overflow-hidden text-ellipsis text-nowrap text-lg/8 font-bold sm:text-2xl/10 uppercase"
    >
      {{ title }}
    </h2>

    <span
      v-if="showNavigation && (!nextDisabled || !previousDisabled)"
      class="flex flex-row gap-2"
      :class="{ 'ml-auto': !title && !icon }"
    >
      <button
        class="button button-new button-new--icon-only touch-manipulation bg-slate-200"
        :disabled="previousDisabled"
        title="Previous Page"
        @click="$emit('previousClick')"
      >
        <AppIcon icon="ArrowLeft" size="xs" class="sm:h-6 sm:w-6"></AppIcon>
      </button>
      <button
        class="button button-new button-new--icon-only -scale-x-100 touch-manipulation bg-slate-200"
        :disabled="nextDisabled"
        title="Next Page"
        @click="$emit('nextClick')"
      >
        <AppIcon icon="ArrowLeft" size="xs" class="sm:h-6 sm:w-6"></AppIcon>
      </button>
    </span>

    <AppButton
      v-if="viewAllRoute"
      title="View all"
      class="button button-new leading-none"
      :route="viewAllRoute"
    >
      View All
    </AppButton>
  </div>
</template>
